import { useEffect, useRef } from 'react';

/**
 * Returns a ref that scrolls its element into view whenever `trigger` becomes truthy.
 * Results render below a 700px map, so without this they can arrive entirely off-screen.
 */
export default function useScrollIntoView(trigger) {
  const ref = useRef(null);

  useEffect(() => {
    if (!trigger || !ref.current) return;
    const node = ref.current;
    const timer = setTimeout(() => {
      try {
        node.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        node.scrollIntoView();
      }
    }, 80);
    return () => clearTimeout(timer);
  }, [trigger]);

  return ref;
}
